// src/data/searchData.js
const searchData = [
    { name: "Accommodation", path: "/accommodation" },
    { name: "Properties", path: "/properties" },
    { name: "Dining", path: "/dining" },
    { name: "Contact", path: "/contact" },
    { name: "Login", path: "/login" },
    { name: "Join Us", path: "/careers" },
];

export default searchData;
